// extracted by mini-css-extract-plugin
module.exports = {"hexContainer":"CounterItem_hexContainer__2hpYw","wanda":"CounterItem_wanda__aTLQ3","hexagon":"CounterItem_hexagon__3RpiS","h":"CounterItem_h__2Bdca","p":"CounterItem_p__1ULHR"};